import POIStep from "@/components/POI/POIStep/POIStep.vue";
import POISkiStateFields from "@/components/POI/POIStateFields/POISkiStateFields/POISkiStateFields.vue";

export default {
  components: { POIStep, POISkiStateFields },
  props: ["step", "position", "editedItem", "isOwnedBySubPrincipal"],
  methods: {
    changeStep(position) {
      this.$emit("changeStep", position);
    }
  }
};
